import { render, staticRenderFns } from "./Autocomplete-suggestions.vue?vue&type=template&id=6745aba0"
import script from "./Autocomplete-suggestions.vue?vue&type=script&lang=js"
export * from "./Autocomplete-suggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports